import { render, staticRenderFns } from "./UtDescriptions.vue?vue&type=template&id=0fa830cc&scoped=true"
import script from "./UtDescriptions.vue?vue&type=script&lang=js"
export * from "./UtDescriptions.vue?vue&type=script&lang=js"
import style0 from "./UtDescriptions.vue?vue&type=style&index=0&id=0fa830cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa830cc",
  null
  
)

export default component.exports